/** All available tenant types */
export enum TenantTypeEnum {
  /** Client tenant - common tenant for "ZaOblako Ltd" clients */
  CLIENT = 'CLIENT',
  /** Admin tenant - "ZaOblako Ltd" personal tenant with admin features */
  ADMIN = 'ADMIN',
  /** Demo tenant - special tenant which use fakes and mocks, need for testing and presentations */
  DEMO = 'DEMO',
}
